<template>
  <el-table-column
    prop="in_date"
    sortable
    label="Bekerülés dátum"
    min-width="150px"
  >
    <template slot-scope="scope">
      {{ scope.row.in_date | date }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'in_date',
  };
</script>
